type Feature =
  | "RECEIVE_VOICE_CALLS"
  | "MEDIA_SHARING"
  | "DOCUMENT_SHARING"
  | "SIMULATE_PING_LATENCY"
  | "RTL_SUPPORT"
  | "VIDEO_MULTI_PARTICIPANT_LAYOUT"
  | "CONTACT_RESUBMIT_NEW_UX";

export default function featureEnabled(name: Feature): boolean {
  const feature = import.meta.env[`VITE_ENABLE_${name}`];
  // If there was a string value provided, it MUST be 'true' when lowered and trimmed
  return feature ? feature.toLowerCase().trim() === "true" : !!feature;
}
